import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getRatesActions, setRatesSearchAction } from '../../redux/actions/ratesActions';
import CreateRateModal from './modals/CreateRateModal';

const RatesHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.rates?.search);
  const [showCreateRateModal, setShowCreateRateModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setRatesSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleRateModalSubmit = async () => {
    setShowCreateRateModal(false);
    setLoading(true);
    await dispatch(getRatesActions(search));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateRateModal && (
        <CreateRateModal
          onModalSubmit={() => handleRateModalSubmit()}
          onModalClose={() => setShowCreateRateModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateRateModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default RatesHeader;
